export const getActiveTabFromUrlAndTabs = (
    viewId: string | undefined,
    tabs: ReadonlyArray<{ value: string }>,
): string | undefined => {
    //If the viewId from the url is valid and exists in the tabs, return it.
    if (viewId && tabs.some((tab) => tab.value === viewId)) return viewId;
    //If there are tabs available, return the first one.
    if (tabs.length > 0) return tabs[0].value;
    return undefined;
};
